module.exports = "/img/_/_/_/assets/images/creeper/battle/common//19.jpg?c77ced052cbbd94ad3a425da34058b5e";